module.exports = __webpack_public_path__ + "static/linda_k-580ab0863aa123bb7732c8b25d1e3c50.png";